import { render, staticRenderFns } from "./WidgetCategoryReviewsListPc.vue?vue&type=template&id=dbd668a0&scoped=true"
import script from "./WidgetCategoryReviewsListPc.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsListPc.vue?vue&type=script&lang=js"
import style0 from "./WidgetCategoryReviewsListPc.vue?vue&type=style&index=0&id=dbd668a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd668a0",
  null
  
)

export default component.exports